import {
  put,
  call,
  takeEvery,
  all,
  takeLatest
} from "redux-saga/effects";
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { API_URL, apiMethod, apiType } from "utils";

import api from "../../client/utils/clientApiHelper";
import { IPayload } from "Model/IPayload";
import * as myOrderActions from "./action";

import {
  GET_VALID_ASSET_DATA_PLANNED,
  GET_CATALOG_ITEM_DETAILS,
  GET_VEHICLE_TYPE_DROPDOWN,
  GET_ADD_ORDER,
  GET_UPLOADED_BLOB_URL_LIST,
  GET_EQUIPMENT_DROPDOWN,
} from "./types";

function* getAssetSubTypesDropdownList(req: any): any {
  try {
    yield put(globalLoaderText("Fetching Vehicle Types..."));
    const assetTypeId = req.assetTypeId;
    let payloadData : IPayload= {
      apiType : apiType.AssetManagement,
      endpoint : `assets/dropdown/assetsubtypes/${assetTypeId}`,
      apiMethod : apiMethod.GET,
      payload : null
    }
    

    const response = yield call(
      api.callAssetPost,API_URL.PostWebApp,payloadData
      
    );
    const defaultVehicleTypeOption = {
      text: "Select Vehicle Type",
      value: null,
    };
    response.unshift(defaultVehicleTypeOption);
    yield put(myOrderActions.SetVehicleTypeDropdown(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(myOrderActions.SetVehicleTypeDropdown([]));
    yield put(globalLoaderText(""));
  }
}

function* getValidAssetDetailsPlannedSaga(req: any): any {
  try {
    const response = yield call(
      api.callOrderPost,
      "order/validateasset",
      req?.assetId?.assetInfo
    );
    yield put(myOrderActions.setAssetValidationPlannedFlag(true));
    yield put(
      myOrderActions.setValidAssetDetailsPlanned({
        res: response,
        id: req.assetId.id,
      })
    );
  } catch (error) {
    yield put(
      myOrderActions.setValidAssetDetailsPlanned({
        res: {},
        id: req.assetId.id,
      })
    );
    yield put(myOrderActions.setAssetValidationPlannedFlag(false));
  }
}

function* getCatalogItemDetails(req: any): any {
  try {
    yield put(globalLoaderText("Fetching Catalog Items..."));
    yield put(myOrderActions.setCatalogItemDetails([], "noRecordsMessage", req?.fleetRequestDetailId ?? null));
    const payloadData: IPayload = {
      apiType: apiType.AssetManagement,
      endpoint: "assets/vehicle/catalogitems",
      apiMethod: apiMethod.POST,
      payload: req.catalogRequestBody,
    };
    const response = yield call(
      api.callAssetPost,
      API_URL.PostWebApp,
      payloadData
    );
    response.forEach((element: any) => {
      element["isSelected"] = false;
    });
    yield put(myOrderActions.setCatalogItemDetails(response, "", req?.fleetRequestDetailId ?? null));
    yield put(globalLoaderText(""));
  } catch (error) {
    const noRecordsMessage = "No Records to display";
    yield put(myOrderActions.setCatalogItemDetails([], noRecordsMessage, req?.fleetRequestDetailId ?? null));
    yield put(globalLoaderText(""));
  }
}

function* createOrderDetails(req: any): any {
  yield put(globalLoaderText("Creating Order...."));
  try {
    let orderRequestBody = req.order;
    const response = yield call(
      api.callOrderPost,
      "orders",
      orderRequestBody
    );
    if (response?.status) {
      yield put(myOrderActions.SetAddOrder([]));
      if (orderRequestBody.orderAction === "Save") {
        yield put(myOrderActions.setIsSaved("fail"));
      }
    } else {
      yield put(myOrderActions.SetAddOrder(response));
      if (orderRequestBody.orderAction === "Save") {
        yield put(myOrderActions.setIsSaved("success"));
      }
    }
    yield put(myOrderActions.setCreateOrderCompleteFlg(true));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(myOrderActions.SetAddOrder([]));
    yield put(myOrderActions.setCreateOrderCompleteFlg(true));
    if (req.order.orderAction === "Save") {
      yield put(myOrderActions.setIsSaved("fail"));
    }
    yield put(globalLoaderText(""));
  }
}

function* getUploadedBlobUrlListSaga(req: any): any {
  try {
    let fileObjList = req.fileObj;
    const response = yield call(
      api.callAssetPost,
      "assets/upload/attachments",
      fileObjList?.fileList
    );
    yield put(
      myOrderActions.setUploadedBlobUrlList({
        id: fileObjList?.id,
        BlobUrlList: response,
      })
    );
    yield put(myOrderActions.setUploadFilesComplete(true));
  } catch (error) {
    yield put(
      myOrderActions.setUploadedBlobUrlList({
        id: req.fileObj?.id,
        BlobUrlList: [],
      })
    );
    yield put(myOrderActions.setUploadFilesComplete(true));
  }
}

function* getEquipmentDropdown(req: any): any {
  try {
    yield put(globalLoaderText("Fetching Equipment Types..."));
    const assetSubTypeId = req.assetSubTypeId;
    let payloadData : IPayload= {
      apiType : apiType.AssetManagement,
      endpoint : `assets/dropdown/assetsubtypes/${assetSubTypeId}`,
      apiMethod : apiMethod.GET,
      payload : null
    }
    

    const response = yield call(
      api.callAssetPost,
      API_URL.PostWebApp,payloadData
    );
    const defaultOption = {
      text: "Select Equipment Type",
      value: null,
    };
    response.unshift(defaultOption);
    yield put(myOrderActions.setEquipmentDropdown(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(myOrderActions.setEquipmentDropdown([]));
    yield put(globalLoaderText(""));
  }
}

function* watchMyOrderSaga() {
  yield takeEvery(GET_CATALOG_ITEM_DETAILS, getCatalogItemDetails);
  yield takeEvery(GET_VEHICLE_TYPE_DROPDOWN, getAssetSubTypesDropdownList);
  yield takeEvery(
    GET_VALID_ASSET_DATA_PLANNED,
    getValidAssetDetailsPlannedSaga
  );
  yield takeEvery(GET_ADD_ORDER, createOrderDetails);
  yield takeEvery(GET_UPLOADED_BLOB_URL_LIST, getUploadedBlobUrlListSaga);
  yield takeEvery(GET_EQUIPMENT_DROPDOWN, getEquipmentDropdown);
}

export default function* combinedSaga() {
  yield all([watchMyOrderSaga()]);
}
